import React, { useEffect, useState } from 'react';
import {  useLocation } from 'react-router-dom';
import axios, { HttpStatusCode } from 'axios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import logoeden from '../../../images/logo-edenred.png';
import CardScreen from '../../shared/components/CardScreen';
import { newPasswordByToken, verifyPasswordToken } from '../services/password.service';
import PasswordReseted from '../components/passwordReseted';
import '../../shared/styles/cards.scss';
import useValidatePassword from '../hooks/useValidatePassword';

const ResetPassword: (props: {}) => JSX.Element = () => {
    
    const [checkCredentials, setCheckCredentials] = useState<string | null>(null);
    const [operated, setOperated] = useState<{commited: boolean, msg: string | null}>({commited: false, msg: null});
    const [urlParams, setUrlParams] = useState<{user: string | null, token: string | null}>({user: null, token: null});
    const [password, setPassword] = useState<{pass: string | null, check: string | null}>({pass: null, check: null});
    const [loading, setLoading] = useState<boolean>(true);
    const location = useLocation();

    useEffect( () => {
        const params = new URLSearchParams(location.search);
        const p_user = params.get('user');
        const p_token = params.get('recoveryToken');
        if (p_token == null || p_token == "" ){
            setLoading(true)
            setOperated({ commited: true, msg: 'Token invalido' });
            setLoading(false)
        }else{
            setUrlParams({user: p_user, token: p_token});
        }
        
    }
    , []);

    useEffect( () => {
        
        if (urlParams.token == null || urlParams.user == null) return;
        const source = axios.CancelToken.source();
        (async () => {
            setLoading(true);
            try {
                const { data, status } = await verifyPasswordToken(urlParams.user!, urlParams.token!, source);
                const msgError = (data?.error == null || data?.error == undefined) ? 'Token Invalido' : data.error.message;
                if (status != HttpStatusCode.Ok || !data.success) setOperated({ commited: true, msg: msgError });
            }
            catch (error) {
                console.log(error);
                setOperated({ commited: true, msg: 'Ocurrio un error al validar la Url' });
            }
            setLoading(false);
        })();
        return () => {
          source.cancel("Pervious request canceled");
        };
      },[urlParams.token]);

    const callReset: () => Promise<void> = async () => {
        const validated: {status: boolean, msg:string} = useValidatePassword({ oriPsw: null, newPsw: password.pass, repPsw: password.check }, true);
        if(!validated.status) {
            setCheckCredentials(validated.msg);
            return;
        } 
        
        setCheckCredentials(null);
        setLoading(true);
        const {data, status} = await newPasswordByToken(urlParams.token!, urlParams.user!, password.pass!);

        if(status != HttpStatusCode.Ok) {
            setOperated({commited: true, msg: 'Ocurrio un error al reiniciar tu Password'});
            setLoading(false);
            return;
        }

        setOperated({commited: true, msg: data.success ? 'Tu Password fue reinicado con exito' : 'Ocurrio un error al reiniciar tu Password'});
        setLoading(false);

    }

    const newPassword: () => JSX.Element = () => {
        return (
            <CardScreen loading={loading} className='eden-main-screen-card'>
            <form style={{ display: 'contents' }} onSubmit={e => { e.preventDefault(); callReset() }}>
                <img alt="EdenRed" src={logoeden} width={'20%'} style={{ marginBottom: '0.5rem' }} />
                <p style={{ fontSize: '1.25rem', textAlign: 'center' }}>{`Ingresa tu nueva contraseña`}</p>
                <div className="p-inputgroup eden-login">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <InputText
                        placeholder="Nuevo Contraseña"
                        value={password.pass!}
                        type='password'
                        onChange={(e) => setPassword({...password, pass: e.target.value})}
                        required />
                </div>
                <div className="p-inputgroup eden-login">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <InputText
                        placeholder="Confirmar Contraseña"
                        value={password.check!}
                        type='password'
                        onChange={(e) => setPassword({...password, check: e.target.value})}
                        required />
                </div>
                <div className='eden-login'>
                    {checkCredentials != null && <p className='p-error' style={{ marginBottom: '1rem', textAlign: 'center' }}>{checkCredentials!}</p>}
                    <Button label="Submit" type="submit" className="btn btn-aceptar btn-block" />
                </div>
            </form>
        </CardScreen>
        );
    }

    return (
        <div className='p-d-flex p-flex-column p-justify-center p-align-center main-container' style={{ padding: 0 }}>
            { !operated.commited && newPassword() }
            { operated.commited && <PasswordReseted message={operated.msg!} loading={loading} /> }
        </div>
    );
};

export default ResetPassword;